import { render } from "./App.vue?vue&type=template&id=54598f04"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=54598f04&lang=css"

import exportComponent from "/opt/lampp/htdocs/vuejs/repeat-your-text/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__